import { render, staticRenderFns } from "./cardScaleView.vue?vue&type=template&id=4340be85"
import script from "./cardScaleView.vue?vue&type=script&lang=js"
export * from "./cardScaleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports